<template>
  <div class="bg-white rounded p-4 mb-auto">
    <div
      class="relative bg-gray-700 rounded overflow-hidden shadow-lg -mt-8 mb-4"
      style="padding-bottom: 50%"
    >
      <img v-if="hasCover" :src="page.cover.source" class="absolute cover inset-0 w-full h-full" />
    </div>
    <h5 class="text-sm font-normal">
      {{ page.name }}
    </h5>
    <span class="block text-xs text-gray-600 mb-4">{{ page.id }}</span>
    <div class="mb-4 text-xs text-green-700 py-2">
      <template v-if="page.accountsCount">
        Linked to Account
        <!-- <span
          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
        >
          {{ account.name }}
        </span> -->
      </template>
      <span v-else>Not linked</span>
    </div>
    <div class="flex space-x-2">
      <RouterLink
        class="inline-flex items-center text-white px-3 py-1 text-sm rounded-sm bg-blue-600 hover:bg-blue-700 hover:text-white transition-colors duration-150 focus:outline-none"
        :to="{
          name: 'admin.facebook.pages.page',
          params: {
            pageId: page.id,
          },
        }"
      >
        View
      </RouterLink>

      <PageUnsubscribe
        v-if="isSubscribed"
        key="subscribe"
        :page-id="page.id"
        @unsubscribe="handleUnsubscribe"
      />

      <PageSubscribe v-else key="unsubscribe" :page-id="page.id" @subscribe="handleSubscribe" />
      <PageEditAction :page-id="page.id" />
    </div>
  </div>
</template>

<script>
import PageSubscribe from './page-subscribe.vue';
import PageUnsubscribe from './page-unsubscribe.vue';
import PageEditAction from './PageEditAction.vue';

export default {
  components: { PageSubscribe, PageUnsubscribe, PageEditAction },
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      rejected: false,
    };
  },
  computed: {
    hasCover() {
      return typeof this.page?.cover?.source === 'string';
    },
    isSubscribed() {
      return this.page.isWebhooksSubscribed === true;
    },
  },
  methods: {
    handleChange(page) {
      this.$emit('change', page);
    },
    handleSubscribe() {
      const page = JSON.parse(JSON.stringify(this.page));
      page.isWebhooksSubscribed = true;
      this.handleChange(page);
    },
    handleUnsubscribe() {
      const page = JSON.parse(JSON.stringify(this.page));
      page.isWebhooksSubscribed = false;
      this.handleChange(page);
    },
  },
};
</script>
